export const validEventTypes = [
  'Information Meeting',
  'Open House',
  'Practicum',
]
